import { Injectable } from "@angular/core";
import { Role } from "app/shared/_models/role";
import { BehaviorSubject } from 'rxjs';
import { UtilitiesService } from "./utilities.service";

@Injectable({ providedIn: 'root' })
export class RoleService {

    private readonly LOCAL_STORAGE_KEY = 'selectedUserRole';
    currentRoleId: number = 0;
    selectedUserRole$ = new BehaviorSubject<Role>(null);
    allowedRoles: Role[] = [] as Role[];

    constructor(private utilitiesService: UtilitiesService) {
        // initialize user role from local storage
        const selectedRole: Role = this.parseRole();
        if (selectedRole) {
            this.setUserRole(selectedRole, false);
        } else {
            this.setUserRole(null, false);
        }
    } // constructor

    private parseRole(): Role {
        try {
            return JSON.parse(this.utilitiesService.getLocal(this.LOCAL_STORAGE_KEY));
        } catch (e) {
            UtilitiesService.consoleLog(e);
            return null;
        }
    }

    public setAllowedRoles(roles: Role[]) {
        this.allowedRoles = roles;
    }

    setUserRole(role: Role, updateLocalStore = true): void {
        if (updateLocalStore) {
            this.utilitiesService.setLocal(this.LOCAL_STORAGE_KEY, JSON.stringify(role));
        }
        this.currentRoleId = role?.id ? role.id : 0;
        this.selectedUserRole$.next(role);
    } // setUserRole()
}
